import { Fragment } from 'react';
import { Collapse, List, ListItem, ListItemText } from '@material-ui/core';

import { CardProduct, ExpandIcon } from '../shared';
import { CustomizationsGroups } from '../customizations-groups';

import { useProductsByCategory } from './hooks';

import makeClasses from './ProductsByCategory.style';

import type {
  FullMenuCatalog,
  IMenuCustomization,
  IMenuProduct,
} from 'features/menu-page/domain';

export function ProductsByCategory(props: Props) {
  const { catalog, toggleOnOff, toggleOnOffCustomization } = props;

  const {
    lang,
    collapse,
    showInternalCustoms,
    selectedProduct,
    productsWithoutCategory,
    handleClickCollapse,
    handleClickProduct,
  } = useProductsByCategory({ catalog });

  const _classes = makeClasses();

  return (
    <div className={_classes.root}>
      <List
        component='section'
        aria-label='productos-by-category'
        classes={{ root: _classes.categories }}
      >
        {catalog.categories.map(category => (
          <Fragment key={`category-${category.id}`}>
            <ListItem
              button
              component='button'
              onClick={handleClickCollapse}
              data-category-id={category.id}
              classes={{ root: _classes.categoryItem }}
            >
              <ExpandIcon
                isExpanded={collapse === category.id}
                className={catalog.categories.length === 1 ? 'displayNone' : ''}
              />
              <ListItemText
                primary={category.name}
                classes={{ primary: _classes.categoryItemTextPrimary }}
              />
            </ListItem>
            <Collapse
              mountOnEnter
              unmountOnExit
              aria-label='product-list-collapse'
              in={collapse === category.id}
            >
              <List disablePadding aria-label='product-list'>
                {catalog.products
                  .filter(p => p.categoryId === category.id)
                  .map(product => (
                    <CardProduct
                      key={`product-${product.id}`}
                      product={product}
                      showHasCustomizations
                      toggleOnOff={toggleOnOff}
                      onSelect={handleClickProduct}
                      isSelected={selectedProduct.id === product.id}
                    />
                  ))}
              </List>
            </Collapse>
          </Fragment>
        ))}

        <ListItem
          button
          component='button'
          onClick={handleClickCollapse}
          data-category-id={-1}
          classes={{ root: _classes.categoryItem }}
          className={productsWithoutCategory.length === 0 ? 'displayNone' : ''}
        >
          <ExpandIcon isExpanded={collapse === -1} />
          <ListItemText
            primary='--- NOT Category ---'
            classes={{ primary: _classes.categoryItemTextPrimary }}
          />
        </ListItem>
        <Collapse
          mountOnEnter
          unmountOnExit
          aria-label='product-list-collapse-without-category'
          in={collapse === -1}
        >
          <List disablePadding aria-label='product-list'>
            {productsWithoutCategory.map(product => (
              <CardProduct
                key={`product-${product.id}`}
                product={product}
                showHasCustomizations
                toggleOnOff={toggleOnOff}
                onSelect={handleClickProduct}
                isSelected={selectedProduct.id === product.id}
              />
            ))}
          </List>
        </Collapse>
      </List>

      {showInternalCustoms && (
        <aside className={_classes.customizationsContainer}>
          <h3 className={_classes.customizationsTitle}>
            {`${lang.aside.title}: ${selectedProduct.name}`}
          </h3>
          <CustomizationsGroups
            catalog={catalog}
            filterByProductId={selectedProduct.id}
            toggleOnOff={toggleOnOffCustomization}
          />
        </aside>
      )}
    </div>
  );
}

interface Props {
  catalog: FullMenuCatalog;
  toggleOnOff: (c: boolean, p: IMenuProduct) => void;
  toggleOnOffCustomization: (c: boolean, item: IMenuCustomization) => void;
}
